import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import Page from '@/components/Page'
import { USER_ATTRIBUTES } from '@/components/User'
import { fetchUsersPaginated } from '@/store/actions'
import { isRequestPending } from '@/store/selectors'

import { fetchGroup, resetPaginationState, setFilter, setSortingColumn } from './actions'
import { FETCH_GROUP_MEMBERS } from './actionTypes'
import GroupMembers from './GroupMembers'
import messages from './messages'
import { getFilter, getGroup, getPageOfGroupMembers, getSortingColumn, getStartIndex, getTotalUsers } from './selectors'

function OrganizationGroupsMembersPage(props: any) {
  const history = useHistory()
  const location = useLocation()
  const params = useParams<{ groupId: string }>()

  const sortOrders = {
    ASC: 'ascending',
    DESC: 'descending'
  }

  const membersPerPage = 10

  // componentWillUnmount
  useEffect(() => {
    return () => {
      props.actions.resetPaginationState()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const loadPage = (page: any, sortBy: any, sortOrder: any, filter: any) => {
    props.actions.setSortingColumn(sortBy, sortOrder)
    props.actions.setFilter(filter)

    const query = {
      attributes: USER_ATTRIBUTES,
      count: membersPerPage,
      // @ts-expect-error
      sortOrder: sortOrders[sortOrder || ''],
      sortBy: sortBy,
      startIndex: (page - 1) * membersPerPage + 1,
      filter: `groups.value eq "${params.groupId}"`
    }

    if (filter) {
      query.filter =
        query.filter +
        ' and (' +
        USER_ATTRIBUTES.map(attribute => `${attribute} co ${JSON.stringify(filter)}`).join(' or ') +
        ')'
    }

    props.actions.fetchGroup(params.groupId)
    props.actions.fetchUsersPaginated(query, FETCH_GROUP_MEMBERS)
  }

  const goBack = () => {
    history.push(
      location.pathname.slice(
        0,
        Math.max(0, location.pathname.lastIndexOf('/', location.pathname.lastIndexOf('/') - 1))
      )
    )
  }

  return (
    <Page className="group-members">
      <Page.Header
        title={<FormattedMessage {...messages.title} />}
        goBack={goBack}
        backNavTitle={<FormattedMessage {...messages.back} />}
      />

      <GroupMembers
        filterValue={props.filterValue}
        group={props.group}
        isFetchingMembers={props.isFetchingMembers}
        loadPage={loadPage}
        perPage={membersPerPage}
        sortingColumn={props.sortingColumn}
        startIndex={props.startIndex}
        memberCount={props.totalItemsCount}
        members={props.members}
      />
    </Page>
  )
}

OrganizationGroupsMembersPage.displayName = 'OrganizationGroupsMembersPage'

OrganizationGroupsMembersPage.propTypes = {
  actions: PropTypes.shape({
    fetchGroup: PropTypes.func.isRequired,
    fetchUsersPaginated: PropTypes.func.isRequired,
    resetPaginationState: PropTypes.func.isRequired,
    setFilter: PropTypes.func.isRequired,
    setSortingColumn: PropTypes.func.isRequired
  }).isRequired,
  filterValue: PropTypes.string,
  group: PropTypes.object,
  isFetchingMembers: PropTypes.bool,
  members: PropTypes.arrayOf(PropTypes.object),
  startIndex: PropTypes.number.isRequired,
  sortingColumn: PropTypes.object,
  totalItemsCount: PropTypes.number.isRequired
}

OrganizationGroupsMembersPage.defaultProps = {
  filterValue: '',
  group: {},
  isFetchingMembers: false,
  sortingColumn: null,
  members: []
}

export { /** @deprecated */ OrganizationGroupsMembersPage }

const mapStateToProps = (state: any) => ({
  filterValue: getFilter(state),
  group: getGroup(state),
  isFetchingMembers: isRequestPending(state, FETCH_GROUP_MEMBERS),
  sortingColumn: getSortingColumn(state),
  startIndex: getStartIndex(state),
  totalItemsCount: getTotalUsers(state),
  members: getPageOfGroupMembers(state)
})

const mapDispatchToProps = (dispatch: any) => ({
  actions: bindActionCreators(
    {
      fetchGroup,
      fetchUsersPaginated,
      resetPaginationState,
      setFilter,
      setSortingColumn
    },
    dispatch
  )
})

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationGroupsMembersPage)
